import { useContext, useRef } from "react";
import { useIsVerified, UserContext } from "../../context/UserContext";

import { useQuestionCreatorId } from "../../Store/QuestionSlice";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { authAxios } from "../../Axios/createAxios";
import { postHandleSubmit } from "../../Axios/fetchFunctions";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useOpenField } from "../../Store/MenuSlice";
import LikeAndDislike from "../LikeAndDislike";

export default function AnswerManagement({ answerId, featured, answerCreatorId }) {
  const queryClient = useQueryClient();
  const { isAuth } = useAuth();
  const questionCreatorId = useQuestionCreatorId();
  const { userInfo } = useContext(UserContext);
  const isVerified = useIsVerified();
  const dislike = () => postHandleSubmit(`/answers/${answerId}/dislike`);
  const like = () => postHandleSubmit(`/answers/${answerId}/like`);
  const navigate = useNavigate();
  const openField = useOpenField();
  async function handleDeleteAnswer() {
    try {
      const res = await authAxios.delete(`/answers/${answerId}`);
      return res;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  const likeMutation = useMutation({
    mutationFn: like,
    onSuccess: (data) => {
      console.log(data);
    },
    onError: (e) => console.log(e),
  });
  const dislikeMutation = useMutation({
    mutationFn: dislike,
    onSuccess: (data) => {
      console.log(data);
    },
    onError: (e) => {
      console.log(e);
    },
  });

  const { mutate } = useMutation({
    mutationFn: handleDeleteAnswer,
    onSuccess: (data) => {
      queryClient.invalidateQueries(["answers"]);
      console.log(data);
    },
    onError: (e) => console.log(e),
  });
  const handleSub = () => {
    if (dislikeMutation.isLoading || likeMutation.isLoading) return false;
    if (!isAuth) {
      navigate("/login");
      return false;
    }
    if (!isVerified) {
      openField("isVerified");
      return false;
    }
    return true;
  };
  const user = userInfo?.id === answerCreatorId || userInfo?.id === questionCreatorId;
  return (
    <>
      <div className={`d-flex flex-around answer-options ${featured ? "opacity-5" : ""}`} title={featured && "dadadd"}>
        <button onClick={() => handleSub() && likeMutation.mutate()}>To give</button>
        {user ? (
          <button onClick={() => mutate()}>delete</button>
        ) : (
          <button
            onClick={() => {
              handleSub() && dislikeMutation.mutate();
            }}>
            To Take
          </button>
        )}
      </div>

      <LikeAndDislike like={likeMutation} dislike={dislikeMutation} pos={"bottom-0"} />
    </>
  );
}
